<div adaptToolbarContent>
    <span class="dx-datagrid-export-button">
        <button adaptButtonIcon="dx-icon dx-icon-xlsxfile"
                adaptTooltip="Export all data"
                (click)="exportAllData()"></button>
    </span>
    <button adaptButtonIcon="dx-icon dx-icon-column-chooser"
            adaptTooltip="Column chooser"
            (click)="showColumnChooser()"></button>
    <button adaptButtonIcon="dx-icon dx-icon-revert"
            adaptTooltip="Reset columns"
            (click)="resetColumns()"></button>
</div>

<dx-data-grid [columnAutoWidth]="true"
              [allowColumnResizing]="true"
              [allowColumnReordering]="true"
              [rowAlternationEnabled]="true"
              [showRowLines]="true"
              [showBorders]="true"
              [stateStoring]="dxGridWrapperHelper.stateStoringOptions"
              [dataSource]="data"
              (onInitialized)="onGridInitialized($event)">
    <dxo-data-grid-header-filter [visible]="true"> </dxo-data-grid-header-filter>
    <dxo-data-grid-filter-row [visible]="true"> </dxo-data-grid-filter-row>
    <dxo-data-grid-paging [pageSize]="25"> </dxo-data-grid-paging>
    <dxo-data-grid-pager [showPageSizeSelector]="true"
                         [allowedPageSizes]="[10, 25, 50, 100, 250]"> </dxo-data-grid-pager>
    <dxo-data-grid-group-panel [visible]="true"> </dxo-data-grid-group-panel>
    <dxo-data-grid-grouping [autoExpandAll]="true"> </dxo-data-grid-grouping>
    <dxo-data-grid-column-chooser [enabled]="false"> </dxo-data-grid-column-chooser>

    <!-- Columns -->
    <dxi-data-grid-column caption="Id"
                          dataField="organisation.organisationId"
                          dataType="number"
                          [allowHeaderFiltering]="false"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Name"
                          dataField="organisation.name"
                          dataType="string"
                          sortOrder="asc"
                          cellTemplate="nameCellTemplate"
                          [allowHeaderFiltering]="false"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Coach"
                          [allowFiltering]="true"
                          [allowHeaderFiltering]="false"
                          dataField="coach"
                          dataType="string"
                          cellTemplate="coachCellTemplate"
                          [calculateCellValue]="calculateCoachCellValue"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Lumia"
                          dataField="organisation.urlIdentifier"
                          dataType="string"
                          [allowHeaderFiltering]="false"
                          cellTemplate="lumiaUrlCellTemplate"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Status"
                          dataField="account.status"
                          dataType="number"
                          [groupIndex]="0"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Sub status"
                          dataField="account.subStatus"
                          dataType="number"
                          [visible]="false"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Type"
                          dataField="account.organisationType"
                          dataType="string"
                          [filterValues]="['Standard']"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Pricing model"
                          dataField="account.pricingModel"
                          dataType="string"
                          [calculateCellValue]="calculatePricingModelCellValue"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Subscription commenced"
                          dataField="account.subscriptionCommencedDate"
                          dataType="date"
                          [format]="dateFormat"
                          [allowSorting]="true"
                          [visible]="false"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Next charge date"
                          dataField="account.nextSubscriptionInvoiceDate"
                          dataType="date"
                          [format]="dateFormat"
                          [allowSorting]="true"
                          [visible]="false"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Monthly fee"
                          dataField="account.extensions.monthlySubscriptionCost"
                          dataType="number"
                          [allowSorting]="true"
                          [visible]="false"
                          [format]="{ type: 'currency' }"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Active users"
                          dataField="account.extensions.totalActiveUsers"
                          dataType="number"
                          [allowSorting]="true"
                          [visible]="false"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Annual fee"
                          dataField="account.extensions.annualSubscriptionCost"
                          dataType="number"
                          [allowSorting]="true"
                          [visible]="false"
                          [format]="{ type: 'currency' }"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Billing period"
                          dataField="account.billingPeriod"
                          dataType="number"
                          [allowSorting]="true"
                          [visible]="false"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Payment method"
                          dataField="account.paymentMethod"
                          dataType="string"
                          [allowSorting]="true"
                          [visible]="false"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Referrer"
                          dataField="referrer"
                          dataType="string"
                          groupCellTemplate="referrerGroupCellTemplate"
                          [visible]="true"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Organisation details"
                          dataField="organisation.organisationDetails.value"
                          dataType="string"
                          cellTemplate="richTextTemplate"
                          [calculateCellValue]="calculateOrganisationDetailCellValue"
                          [visible]="false"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Partner"
                          dataField="account.partner"
                          dataType="string"
                          [calculateCellValue]="calculatePartnerCellValue"
                          [visible]="false"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Key contact"
                          dataField="account.keyContactPersonId"
                          dataType="string"
                          cellTemplate="personCellTemplate"
                          [allowHeaderFiltering]="false"
                          [calculateCellValue]="calculateKeyContactCellValue"
                          [visible]="false"> </dxi-data-grid-column>

    <!-- Templates -->
    <div *dxTemplate="let item of 'nameCellTemplate'">
        <adapt-link-organisation [organisation]="item.data.organisation"> </adapt-link-organisation>
    </div>
    <div *dxTemplate="let item of 'coachCellTemplate'">
        @for (coach of item.data.coaches; track coach) {
            <div>
                <adapt-link-coach [coach]="coach"></adapt-link-coach>
            </div>
        }
    </div>
    <div *dxTemplate="let item of 'personCellTemplate'">
        <adapt-link-person [personId]="item.data.account.keyContactPersonId"></adapt-link-person>
    </div>
    <div *dxTemplate="let item of 'lumiaUrlCellTemplate'">
        <a target="_blank"
           [href]="getLumiaLinkForOrganisation(item.data.organisation)">{{ item.value }}</a>
    </div>
    <div *dxTemplate="let data of 'richTextTemplate'">
        <div [froalaView]="data.value"></div>
    </div>
    <div *dxTemplate="let item of 'referrerGroupCellTemplate'">Referrer: {{ item.value ?? "None" }}</div>
</dx-data-grid>
